module.exports = __webpack_public_path__ + "img/capitole-indemnatoare-1691-pagina-de-titlu-big.a6fddde8.jpg";